import * as Immutable from "immutable";
import { SEVEN_DAYS_AGO, TODAY } from "services/date-strings";
import { AnalyticsRequestParams } from "../legacyServices";

export class AnalyticsSatisfactionRequestParams extends AnalyticsRequestParams {
  static Filter = Immutable.Record({
    /** @memberof AnalyticsSatisfactionRequestParams.Filter# */
    startDate: SEVEN_DAYS_AGO,
    /** @memberof AnalyticsSatisfactionRequestParams.Filter# */
    endDate: TODAY,
    /** @memberof AnalyticsSatisfactionRequestParams.Filter# */
    timeSeriesUnit: "day",
    /** @memberof AnalyticsSatisfactionRequestParams.Filter# */
    version: undefined
  });
}

const initialState = {
  requestParams: new AnalyticsSatisfactionRequestParams({
    filter: new AnalyticsSatisfactionRequestParams.Filter()
  })
};

/**
 * @param {Object} state
 * @param {{properties: Object}} action
 * @returns {Object}
 */
function updateFilter(state, action) {
  const {
    /** @type AnalyticsSatisfactionRequestParams */
    requestParams
  } = state;

  // Create new requestParams object using `action.properties`
  let newRequestParams = new AnalyticsSatisfactionRequestParams({
    ...requestParams,
    filter: new AnalyticsSatisfactionRequestParams.Filter({
      ...requestParams.filter.toObject(),
      ...action.properties
    })
  });

  // If updated properties include dates, we need to check if unit should be updated accordingly
  if (
    Object.keys(action.properties).some(key => ["startDate", "endDate"].includes(key)) &&
    !newRequestParams.allowedUnitValues.includes(requestParams.filter.timeSeriesUnit)
  ) {
    newRequestParams = new AnalyticsSatisfactionRequestParams({
      ...requestParams,
      filter: new AnalyticsSatisfactionRequestParams.Filter({
        ...requestParams.filter.toObject(),
        ...action.properties,
        timeSeriesUnit: newRequestParams.allowedUnitValues[0]
      })
    });
  }

  return {
    ...state,
    requestParams: newRequestParams
  };
}

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function analyticsSatisfaction(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_ANALYTICS_SATISFACTION_FILTER": {
      return updateFilter(state, action);
    }

    default: {
      return state;
    }
  }
}
